module.exports = __webpack_public_path__ + "img/私信.1cdf1489.png";